import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { ABORT_CONFIGURATION } from "../../store/actions/externalActions";

const CancelButton = styled.div`
    position: absolute;
    top: 13px;
    right: 15px;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 2px 5px 0 rgba(0, 0, 0, 0.2);
    transition: background 0.2s ease-in-out;
    color: rgb(0, 0, 0, 0.3);
    z-index: 10;
    cursor: pointer;
    ${({ theme }) =>
        theme.buttonBack.mode === "secondary"
            ? `background: rgba(242,242,242, 0.6);`
            : `background: ${theme.buttonBack.backgroundColor}; border: none;`}
    &:hover {
        ${({ theme }) =>
            theme.buttonBack.mode === "secondary"
                ? `background: rgba(242,242,242, 0.7);`
                : `background: ${theme.buttonBack.hoverColor};`}
    }
    &:active {
        ${({ theme }) =>
            theme.buttonBack.mode === "secondary"
                ? `background: rgba(242,242,242, 0.8);`
                : `background: ${theme.buttonBack.activeColor};`}
    }
`;

export const MobileCancelButton = () => {
    const dispatch = useDispatch();
    return (
        <CancelButton onClick={() => dispatch({ type: ABORT_CONFIGURATION })}>
            <span className="material-icons">close</span>
        </CancelButton>
    );
};
